import { ICandidateSourcingFilters, FilterKey, YearsOfExperienceRange } from '../types';

export const addFilterValue = (
  filters: ICandidateSourcingFilters,
  key: FilterKey,
  value: string | YearsOfExperienceRange
): ICandidateSourcingFilters => {
  const newFilters = { ...filters };

  switch (key) {
    case 'job_titles':
      newFilters.job_titles = [...(newFilters.job_titles || []), value];
      break;
    case 'industries':
      newFilters.industries = [...(newFilters.industries || []), value];
      break;
    case 'skills':
      newFilters.skills = [...(newFilters.skills || []), [value]];
      break;
    case 'locations':
      newFilters.locations = [...(newFilters.locations || []), value];
      break;
    case 'years_of_experience':
      if (typeof value === 'string') {
        const parsed = parseInt(value, 10);
        if (!Number.isNaN(parsed)) {
          newFilters.years_of_experience = { min: parsed };
        }
      } else {
        const sanitized = sanitizeYearsOfExperience(value);
        if (sanitized) {
          newFilters.years_of_experience = sanitized;
        } else {
          delete newFilters.years_of_experience;
        }
      }
      break;
  }

  return newFilters;
};

export const removeFilterValue = (
  filters: ICandidateSourcingFilters,
  key: FilterKey,
  index?: number,
  subIndex?: number
): ICandidateSourcingFilters => {
  const newFilters = { ...filters };

  switch (key) {
    case 'job_titles':
      if (index !== undefined) {
        newFilters.job_titles = newFilters.job_titles?.filter((_, i) => i !== index);
      }
      break;
    case 'industries':
      if (index !== undefined) {
        newFilters.industries = newFilters.industries?.filter((_, i) => i !== index);
      }
      break;
    case 'skills':
      if (index !== undefined && subIndex !== undefined) {
        newFilters.skills = newFilters.skills
          ?.map((group, i) => (i === index ? group.filter((_, j) => j !== subIndex) : group))
          .filter((group) => group.length > 0);
      }
      break;
    case 'location':
      delete newFilters.location;
      break;
    case 'years_of_experience':
      delete newFilters.years_of_experience;
      break;
  }

  return newFilters;
};

export const sanitizeYearsOfExperience = (
  value: { min?: number | null; max?: number | null } | number | string | null | undefined
) => {
  if (value === null || value === undefined) return undefined;

  if (typeof value === 'number') {
    if (Number.isNaN(value)) return undefined;
    return { min: value };
  }

  if (typeof value === 'string') {
    const parsed = parseInt(value, 10);
    if (Number.isNaN(parsed)) return undefined;
    return { min: parsed };
  }

  if (typeof value !== 'object') {
    return undefined;
  }

  const result: { min?: number; max?: number } = {};
  const { min, max } = value as { min?: number | null; max?: number | null };

  if (min !== undefined && min !== null && !Number.isNaN(Number(min))) {
    const parsedMin = parseInt(String(min), 10);
    if (!Number.isNaN(parsedMin)) {
      result.min = parsedMin;
    }
  }

  if (max !== undefined && max !== null && !Number.isNaN(Number(max))) {
    const parsedMax = parseInt(String(max), 10);
    if (!Number.isNaN(parsedMax)) {
      result.max = parsedMax;
    }
  }

  if (Object.keys(result).length === 0) {
    return undefined;
  }

  return result;
};
